import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import withStyles from '@material-ui/core/styles/withStyles';

export const styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    flex: '0 0 auto',
    '& > *': {
      margin: '0 4px',
    },
    paddingRight: 418,
  },
  rightSide: {
    paddingRight: 48,
  },
};

function ToolbarActions(props) {
  const { children, classes, className, rightSide, ...other } = props;

  return (
    <div
      className={classNames(classes.root, className, { [classes.rightSide]: rightSide })}
      {...other}
    >
      {children}
    </div>
  );
}

ToolbarActions.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
  rightSide: PropTypes.bool,
};

export default withStyles(styles, { name: 'ToolbarActions' })(ToolbarActions);
